import { WideoDefVersion } from "../../core/model/WideoDef";
import ITransformer from "../ITransformer";

export default class TransformerToV74 implements ITransformer {
  readonly toVersion: WideoDefVersion = WideoDefVersion.V74;

  // tslint:disable-next-line:no-any
  public transformWideo(wideoDef: any) {

    // No update needed for wideoDef, just update the version and timestamp
    // Update version and timestamp
    wideoDef.version = this.toVersion;
    wideoDef.timeStamp = Date.now();

    for (const sceneDef of wideoDef.scenes) {
      this.transformScene(sceneDef);
    }

  }

  // tslint:disable-next-line:no-any
  transformScene(sceneDef: any): void {
    //Update version
    sceneDef.version = this.toVersion;
  }

} 